module.exports = {
  PhoneNumberUtil: {
    getInstance() {
      return null;
    },
  },
};
